import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import fontawesome from '@fortawesome/fontawesome';
import { faCopy, faTrash } from '@fortawesome/fontawesome-free-solid';


fontawesome.library.add(faCopy, faTrash);

Vue.config.productionTip = false

new Vue({
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.ts